import DeleteIcon from '@mui/icons-material/Delete';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import SearchIcon from '@mui/icons-material/Search';
import InputText from '@/trio-ui/InputText';
import Modal from '@/trio-ui/Modal';
import type { ComponentProps } from './types';
import { FIELDS, HEADERS } from './ExportMembersModal.constants';
import * as Styles from './ExportMembersModal.styles';

const ExportMembersModal = ({
  search,
  onSearchChange,
  selectedFields = [],
  onSelectField,
  onRemoveField,
  onExportClick,
  isLoadingAdditionalData = false,
  ...modalProps
}: ComponentProps): JSX.Element => {
  const body = (
    <Styles.Divider>
      <Styles.Division>
        <Styles.Subtitle>Available info</Styles.Subtitle>
        <InputText
          isLabelAboveField
          placeholder="Search for a field"
          leadingIcon={SearchIcon}
          value={search}
          onChange={(e) => onSearchChange?.(e.target.value)}
        />
        <Styles.List>
          {FIELDS.filter((field) => {
            if (!HEADERS[field].toLowerCase().includes((search || '').toLowerCase())) return false;
            return !selectedFields.some((selectedField) => selectedField === field);
          }).map((field) => (
            <Styles.ListItem key={field} onClick={() => onSelectField?.(field)}>
              {HEADERS[field]}
            </Styles.ListItem>
          ))}
        </Styles.List>
      </Styles.Division>
      <Styles.Division>
        <Styles.Subtitle>Exporting</Styles.Subtitle>
        <Styles.List>
          {selectedFields.map((field) => (
            <Styles.ListItem key={field} onClick={() => onRemoveField?.(field)}>
              {HEADERS[field]}
              <div>
                <DeleteIcon />
                Remove
              </div>
            </Styles.ListItem>
          ))}
        </Styles.List>
      </Styles.Division>
    </Styles.Divider>
  );

  return (
    <Modal
      headerIcon={OpenInNewIcon}
      modalTitle="Exporting Team Members List"
      size="3xl"
      isCentered
      {...modalProps}
      bodyRender={body}
      onConfirmClick={onExportClick}
      onConfirmLabel="Export"
      isButtonDisabled={isLoadingAdditionalData}
    />
  );
};

export default ExportMembersModal;
